module.exports = __webpack_public_path__ + "img/wet.aeb23013.svg";